import { SegmentationFilters } from "@app/models/segmentation-filters";
import { createAction, props } from "@ngrx/store";

export const setContactsFilters = createAction(
  "[Lists Contacts] SET_CONTACTS_FILTERS",
  props<{ filters: Partial<SegmentationFilters> }>()
);
